/*eslint no-constant-condition: ["error", { "checkLoops": false }]*/
import React, { useRef, useEffect } from 'react';
import { TweenLite, Linear } from 'gsap';
import css from './AnimatedHeader.module.css';

interface Props {
    message: string;
    len: number;
    dur: number;
}

export const AnimatedHeader: React.FC<Props> = ({
    message,
    len,
    dur,
}: {
    message: string;
    len: number;
    dur: number;
}) => {
    let moving: any = useRef(null);
    useEffect(() => {
        TweenLite.fromTo(moving, dur, { x: 0 }, { x: len, ease: Linear.easeNone, repeat: -1 });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [moving, len]);

    return (
        <div className={css.wrapper}>
            <div
                className="am_gdpr_moving"
                ref={(el) => {
                    moving = el;
                }}
            >
                <h1>{message}</h1>
                <h1>{message}</h1>
            </div>
        </div>
    );
};
